const types = require('../../constants/actionTypes');


const closed = () => ({
    type: types.FUNDBOX_CLOSED,
});


module.exports = closed;
